export default "__VITE_ASSET__BlaXutU8__"